<template>
  <div>
    <div v-if="error">
      <!-- By default, Show nothing if any error, but if error slot is passed then show error slot UI -->
      <slot name="error">
        <div
          class="fe-spacing fe-spacing-vertical sm:fe-spacing-horizontal fe-flex fe-flex-col fe-justify-center fe-items-center"
        >
          <div class="fe-text-heading-xxs lg:fe-text-heading-xs fe-mb-s">
            Oops, Something went wrong!
          </div>
          <div class="fe-text-body-xxs lg:fe-text-body-s fe-mb-xxl">
            Please try refreshing the page, or try again after some time to see
            the product reviews.
          </div>
          <div class="fe-w-full lg:fe-w-1/2">
            <JdsButton
              variant="primary"
              size="large"
              :fullWidth="true"
              @click="reloadPage"
            >
              Try Again
            </JdsButton>
          </div>
        </div>
      </slot>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"

  export default {
    name: "ErrorBoundary",
    components: {
      JdsButton,
    },
    data() {
      return {
        error: null,
      }
    },
    errorCaptured(err, vm, info) {
      // Catch the error and set it in the state
      this.error = err
      // Also, log the error or send it to an external service if needed
      console.error("FE_ERROR", err, info)
      // Return false to stop the error from propagating further
      return false
    },
    methods: {
      reloadPage() {
        window.location.reload()
      },
    },
  }
</script>
